import React from 'react';
import Icon from '../../../components/AppIcon';

const IndustryHero = () => {
  return (
    <section className="relative bg-gradient-to-br from-primary/5 via-background to-accent/5 py-16 md:py-24 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-10 w-64 h-64 bg-primary rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-accent rounded-full blur-3xl"></div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center max-w-4xl mx-auto">
          <div className="inline-flex items-center space-x-2 bg-primary/10 text-primary px-4 py-2 rounded-full text-sm font-medium font-body mb-6">
            <Icon name="Building2" size={16} />
            <span>Industry Expertise</span>
          </div>
          
          <h1 className="text-3xl md:text-4xl lg:text-6xl font-bold font-headline text-foreground mb-6 leading-tight">
            Vertical-Specific Solutions for{' '}
            <span className="text-primary">Complex Industries</span>
          </h1>
          
          <p className="text-base md:text-lg lg:text-xl text-muted-foreground font-body mb-8 leading-relaxed">
            Deep domain expertise meets technical excellence. We understand the unique challenges, regulatory requirements, and business dynamics of your industry—delivering SaaS solutions that drive measurable transformation.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <div className="flex items-center space-x-3 bg-card px-6 py-3 rounded-lg shadow-sm">
              <Icon name="Award" size={20} className="text-success" />
              <span className="text-sm font-medium font-body text-foreground">15+ Years Combined Experience</span>
            </div>
            <div className="flex items-center space-x-3 bg-card px-6 py-3 rounded-lg shadow-sm">
              <Icon name="TrendingUp" size={20} className="text-accent" />
              <span className="text-sm font-medium font-body text-foreground">98% Client Satisfaction</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndustryHero;